import SidePanelView from './side-panel-view'

export default SidePanelView
